import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { FieldErrors } from './FieldErrors';

import { useFieldContext } from '.';

interface Props {
  label: string;
  options: string[];
  placeholder?: string;
  className?: string;
}

export function MonsterMultiSelect({
  label,
  options,
  placeholder = 'Please select at least one option',
  className = ''
}: Props) {
  const field = useFieldContext<string[]>();

  return (
    <Listbox value={field.state.value || []} onChange={(v) => field.handleChange(v)} multiple>
      <div className='flex w-full flex-col justify-center gap-3'>
        <label htmlFor={field.name} className='block leading-6 font-medium'>
          {label}
        </label>
        <div className='relative'>
          <ListboxButton
            className={`ring-monsterPurple focus:ring-monsterGreen text-siteBackground nice-focus transitiona-all w-full cursor-pointer rounded-lg border-0 bg-white px-3 py-2 text-left ring-2 duration-200 ease-in-out outline-none ring-inset ${className}`}
          >
            <span className='block truncate'>
              {field.state.value?.length === 0 ? placeholder : field.state.value?.join(', ')}
            </span>
            <span className='pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3'>
              <ChevronDownIcon className='h-5 w-5 text-gray-400' aria-hidden='true' />
            </span>
          </ListboxButton>
          <ListboxOptions className='ring-monsterPurple ring-opacity-5 absolute z-10 mt-1 max-h-60 w-full overflow-y-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 focus:outline-none sm:text-sm'>
            {options.map((option, index) => (
              <ListboxOption
                key={index}
                value={option}
                className={({ focus, selected }) =>
                  `${focus ? 'bg-monsterGreen text-siteBackground' : 'text-siteBackgroundLighter'} ${selected ? 'bg-monsterGreen/10 text-siteBackgroundLighter' : ''} relative cursor-pointer py-2 pr-4 pl-10 select-none`
                }
              >
                {({ selected }) => (
                  <>
                    <span className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}>{option}</span>
                    {selected ? (
                      <span className='text-monsterGreen absolute inset-y-0 left-0 flex items-center pl-3'>
                        <svg className='h-5 w-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                          <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M5 13l4 4L19 7'></path>
                        </svg>
                      </span>
                    ) : null}
                  </>
                )}
              </ListboxOption>
            ))}
          </ListboxOptions>
        </div>
      </div>
      <FieldErrors meta={field.state.meta} />
    </Listbox>
  );
}
